<template>
    <div>
        <div class="mt-3 mb-3 w-100 d-flex justify-content-between">
            <b-form inline>
                <label class="mt-2 L-head mr-3 text-dark f-2">
                    Year :
                </label>
                <Select2
                    class="L-head"
                    v-model="YearDataNew"
                    :options="optionsSelectYearNew"
                    :settings="{ placeholder:'Please select year',width:'100%' }"
                    @change="getDataSumLeave"
                />
            </b-form>         
            <!-- btn createform -->
            <!-- <b-button @click="openFormLeave" class="text-capitalize btn-sm font-weight-bold" variant="info"><i class="mr-1 fa fa-pencil-square-o" aria-hidden="true" />Write a leave</b-button> -->
        </div>
        <div v-if="cardBusy" class="thai-font text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            Load absent Inforamtion...
        </div>
        <div v-else>
            <div class="row">
                <div class="col-sm-12 col-lg-6 col-md-6 col-xl-3">
                    <b-jumbotron class="text-center mt-2 jumbotron-custom animate__animated animate__flipInX">
                        <img  width="64" src="@/assets/img/holiday-icon.png" alt="MUIC">
                        <hr class="custom-hr mt-2 mb-2">
                        <h5 class="f-500 mt-1 mb-0 L-head">
                            Vacation leave<i id="popover-4" class="fa fa-info-circle ml-1 align-top L-smallIcon" aria-hidden="true"></i>
                            <b-popover custom-class="popover-custom" placement="right" target="popover-4" triggers="hover focus">
                                <template v-slot:title></template>
                                <ul class="mt-2">
                                    <li class="L-info">
                                        <u>พนักงานวิทยาลัยสายวิชาการ</u> มีสิทธิลาพักผ่อนประจำปีโดยได้รับ เงินเดือนปีละไม่เกิน 10 วันทำการ *** เวันแต่กรณีที่เข้าปฏิบัติงานในปีแรก ยังไม่ครบ 6 เดือน ไม่มีสิทธิ์ลาพักผ่อนประจำปี *** กรณีใช้สิทธิลาพักผ่อนประจำปีแล้ว แต่ยังไม่ครบ 10 วันทำการ สามารถสะสมวันที่ยังมิได้ลาในปีหนึ่ง ๆ รวมกับวันลาของปีต่อไปได้ แต่ไม่เกิน 20 วันทำการ
                                    </li>
                                    <li class="L-info">
                                        <u>
                                            พนักงานวิทยาลัยสายสนับสนุน</u> มีสิทธิลาพักผ่อนประจำปี โดยได้รับเงินเตือนตามกำหนด ดังนี้
                                            <br>
                                            <span class="text-dager">*** การนับอายุงานจะนับตามปีงบประมาณ ***</span>
                                        <ul>
                                            <li class="L-info">อายุการทำงานครบ 6 เดือนในปีแรก มีสิทธิลาพักผ่อนประจำปี ได้ไม่เกิน 7 วันทำการ</li>
                                            <li class="L-info">อายุการทำงานครบ 1 ปีขึ้นไป แต่ไม่ถึง 5 ปี มีสิทธิลาพักผ่อน ประจำปีได้ 10 วันทำการ</li>
                                            <li class="L-info">อายุการทำงานครบ 5 ปีขึ้นไปแต่ไม่ถึง 10 ปี มีสิทธิลาพักผ่อนประจำปีได้ 12 วันทำการ</li>
                                            <li class="L-info">อายุการทำงานครบ 10 ขึ้นไป มีสิทธิลาพักผ่อนประจำปีได้ 15 วันทำการ</li>
                                        </ul>
                                    </li>
                                    <li class="L-info"><u>การลาพักผ่อนประจำปี</u> จะไม่สามารถสะสมในปีถัดไปได้ และไม่มีการจ่ายชดเชย</li>
                                </ul>
                            </b-popover>
                        </h5>
                        <h3 class="mt-1 mb-0 L-Number">{{ ObjData.typeSum_2 }} <small>/ {{ ObjDataLimit.typeLimt }}</small></h3>
                    </b-jumbotron>
                </div>
                <div class="col-sm-12 col-lg-6 col-md-6 col-xl-3">
                    <b-jumbotron  class="text-center mt-2 jumbotron-custom animate__animated animate__flipInX">
                        <img  width="64" src="@/assets/img/sick-icon-1.png" alt="MUIC">
                        <hr class="custom-hr mt-2 mb-2">
                        <h5 
                            
                            class="f-500 mt-1 mb-0 L-head"
                        >
                            Sick leave<i id="popover-3" class="fa fa-info-circle ml-1 align-top L-smallIcon" aria-hidden="true"></i>
                            <b-popover custom-class="popover-custom" placement="top" target="popover-3" triggers="hover focus">
                                <template v-slot:title></template>
                                <ul class="mt-2">
                                    <li class="L-info">กรณีปกติลาได้ไม่เกิน 60 วันทำการ</li>
                                    <li class="L-info">กรณีต้องพักรักษาตัวในโรงพยาบาล รักษาตัวต่อเนื่องตามความเห็นแพทย์ลาได้ไม่เกิน 60 วันทำการ/ปี รวมทั้งปีลาได้ 120 วันทำการ(ได้รับเงินเดือน)</li>
                                    <li class="L-info">ลาเกิน 3 วันติดต่อกันต้องมีใบรับรองแพทย์</li>
                                </ul>
                            </b-popover>
                        </h5>
                        <h3 class="mt-1 mb-0 L-Number">{{ ObjData.typeSum_1 }} <small>/ 60</small></h3>  
                    </b-jumbotron>
                </div>
                <div class="col-sm-12 col-lg-6 col-md-6 col-xl-3">
                    <b-jumbotron class="text-center mt-2 jumbotron-custom animate__animated animate__flipInX">
                        <img  width="64" src="@/assets/img/sick-icon.png" alt="MUIC">
                        <hr class="custom-hr mt-2 mb-2">
                        <h5 class="f-500 mt-1 mb-0 L-head">
                            Medical Leave<i id="popover-Medical" class="fa fa-info-circle ml-1 align-top L-smallIcon" aria-hidden="true"></i>
                            <b-popover custom-class="popover-custom" placement="top" target="popover-Medical" triggers="hover focus">
                                <template v-slot:title></template>
                                <ul class="mt-2">
                                    <li class="L-info">กรณีปกติลาได้ไม่เกิน 60 วันทำการ</li>
                                    <li class="L-info">กรณีต้องพักรักษาตัวในโรงพยาบาล รักษาตัวต่อเนื่องตามความเห็นแพทย์ลาได้ไม่เกิน 60 วันทำการ/ปี รวมทั้งปีลาได้ 120 วันทำการ(ได้รับเงินเดือน)</li>
                                    <li class="L-info">ลาเกิน 3 วันติดต่อกันต้องมีใบรับรองแพทย์</li>
                                </ul>
                            </b-popover>
                        </h5>
                        <h3 class="mt-1 mb-0 L-Number">{{ ObjData.typeSum_5 }} <small>/ 120</small></h3>  
                    </b-jumbotron>
                </div>
                <div class="col-sm-12 col-lg-6 col-md-6 col-xl-3">
                    <b-jumbotron class="text-center mt-2 jumbotron-custom animate__animated animate__flipInX">
                        <img  width="64" src="@/assets/img/extra-icon-other.png" alt="MUIC">
                        <hr class="custom-hr mt-2 mb-2">
                        <h5 class="f-500 mt-1 mb-0 L-head">
                            Extra Leave<i id="popover-Extra" class="fa fa-info-circle ml-1 align-top L-smallIcon" aria-hidden="true"></i>
                            <b-popover custom-class="popover-custom" placement="top" target="popover-Extra" triggers="hover focus">
                                <template v-slot:title></template>
                                <ul class="mt-2">
                                    <li class="L-info">ให้รองคณบดีต้นสังกัดพิจารณาตามความเหมาะสม</li>
                                </ul>
                            </b-popover>
                        </h5>
                        <h3 class="mt-1 mb-0 L-Number">{{ ObjData.typeSum_4 }} <small>Days</small></h3>
                    </b-jumbotron>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-lg-6 col-md-6 col-xl-3">
                    <b-jumbotron class="text-center mt-2 jumbotron-custom animate__animated animate__flipInX">
                        <img  width="64" src="@/assets/img/leave-icon.png" alt="MUIC">
                        <hr class="custom-hr mt-2 mb-2">
                        <h5 class="f-500 mt-1 mb-0 L-head">Casual leave</h5>
                        <h3 class="mt-1 mb-0 L-Number">{{ ObjData.typeSum_6 }} <small>Days</small></h3>
                    </b-jumbotron>
                </div>
                <div class="col-sm-12 col-lg-6 col-md-6 col-xl-3">
                    <b-jumbotron class="text-center mt-2 jumbotron-custom animate__animated animate__flipInX">
                        <img  width="64" src="@/assets/img/mook-icon.png" alt="MUIC">
                        <hr class="custom-hr mt-2 mb-2">
                        <h5 class="f-500 mt-1 mb-0 L-head">
                            Monkhood leave<i id="popover-Monkhood" class="fa fa-info-circle ml-1 align-top L-smallIcon" aria-hidden="true"></i>
                            <b-popover custom-class="popover-custom" placement="top" target="popover-Monkhood" triggers="hover focus">
                                <template v-slot:title></template>
                                <ul class="mt-2">
                                    <li class="L-info">พนักงานวิทยาลัยที่ยังไม่เคยลาอุปสมบทและประสงค์จะอุปสมบท หรือพนักงานวิทยาลัยที่นับถือศาสนาอิสลามซึ่งประสงค์จะลาไปประกอบพิธีฮัจย์ ณ เมืองเมกกะ ประเทศชาอุดิอาระเบียมีสิทธิลาอุปสมบท หรือไปประกอบพิธีฮัจย์ โดยได้รับเงินเดือนได้ไม่เกิน 120 วัน</li>
                                    <li class="L-info">พนักงานวิทยาลัยจะขอลาอุปสมบท หรือ ขอลาไปประกอบพิธีฮัจย์อย่างหนึ่งอย่างใดได้เพียงครั้งเดียว</li>
                                </ul>
                            </b-popover>
                        </h5>
                        <h3 class="mt-1 mb-0 L-Number">{{ ObjData.typeSum_3 }} <small>/ 120</small></h3>
                    </b-jumbotron>
                </div>
                <div class="col-sm-12 col-lg-6 col-md-6 col-xl-3">
                    <b-jumbotron class="text-center mt-2 jumbotron-custom animate__animated animate__flipInX">
                        <img  width="64" src="@/assets/img/maternity-icon.png" alt="MUIC">
                        <hr class="custom-hr mt-2 mb-2">
                        <h5 class="f-500 mt-1 mb-0 L-head">
                            Maternity leave<i id="popover-Maternity" class="fa fa-info-circle ml-1 align-top L-smallIcon" aria-hidden="true"></i>
                            <b-popover custom-class="popover-custom" placement="top" target="popover-Maternity" triggers="hover focus">
                                <template v-slot:title></template>
                                <ul class="mt-2">
                                    <li class="L-info">ลาครั้งหนึ่งได้ไม่เกิน 90 วันโดยจะได้เงินเดือน 45 วันแรก</li>
                                    <li class="L-info">
                                        ดูแลบุตรและภรรยาหลังคลอด
                                        <ul>
                                            <li class="L-info">ลาได้เฉพาะ พม./พส. ประเภทชาย</li>
                                            <li class="L-info">เป็นภรรยาที่ถูกต้องตามกฏหมาย</li>
                                            <li class="L-info">ลาได้ครั้งละไม่เกิน 15 วันทำการ (ได้รับเงินเดือนตามปกติ)</li>
                                        </ul>
                                    </li>
                                </ul>
                            </b-popover>
                        </h5>
                        <h3 class="mt-1 mb-0 L-Number">{{ ObjData.typeSum_7 }} <small>/ 90</small></h3>
                    </b-jumbotron>
                </div>
                <div class="col-sm-12 col-lg-6 col-md-6 col-xl-3">
                    <b-jumbotron class="text-center mt-2 jumbotron-custom animate__animated animate__flipInX">
                        <img  width="64" src="@/assets/img/extra-icon.png" alt="MUIC">
                        <hr class="custom-hr mt-2 mb-2">
                        <h5 class="f-500 mt-1 mb-0 L-head">
                            Other leave<i id="popover-other" class="fa fa-info-circle ml-1 align-top L-smallIcon" aria-hidden="true"></i>
                            <b-popover custom-class="popover-custom" placement="top" target="popover-other" triggers="hover focus">
                                <template v-slot:title></template>
                                <ul class="mt-2">
                                    <li class="L-info">ให้รองคณบดีต้นสังกัดพิจารณาตามความเหมาะสม</li>
                                </ul>
                            </b-popover>
                        </h5>
                        <h3 class="mt-1 mb-0 L-Number">{{ ObjData.typeSum_8 }} <small>Days</small></h3>
                    </b-jumbotron>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const DataLeave = {
        typeSum_1 : 0,
        typeSum_2 : 0,
        typeSum_3 : 0,
        typeSum_4 : 0,
        typeSum_5 : 0,
        typeSum_6 : 0,
        typeSum_7 : 0,
        typeSum_8 : 0,
    }
    const DataLeaveLimit = {
        typeLimt : 0,
    }

    // import
    import Select2 from 'v-select2-component';
    
    export default {
        components: { Select2 },
        data(){
            return {
                cardBusy:false,
                YearDataNew : null,
                optionsSelectYearNew: [],
                ObjData: Object.assign({}, DataLeave),
                ObjDataLimit: Object.assign({}, DataLeaveLimit),
            }
        },
        mounted(){
            // this.callSumyear()
            this.getDataSumLeave()
        },
        methods: {
            async callSumyear(){},
            async getDataSumLeave(){
                if(this.YearDataNew === null){
                    try {
                        const res = await this.$http.get(`/hri/leave_of_absence/view_year/`)
                        if (res.status === 200) {
                            this.optionsSelectYearNew =  res.data.map(item => {
                                return {
                                    'id': item.year,
                                    'text': `${item.year} / ${parseInt(item.year) + parseInt(543)}`
                                }
                            })
                            // sort
                            this.optionsSelectYearNew.sort((a, b) =>{ return b.id - a.id; });
                            this.YearDataNew = this.optionsSelectYearNew[0].id
                            var url = `/hri/leave_of_absence/summary_absence/?year=${this.optionsSelectYearNew[0].id}`
                        }
                    } catch (error) {}
                }else{
                    var url = `/hri/leave_of_absence/summary_absence/?year=${this.YearDataNew}`
                }
                this.$emit("YearChange", this.YearDataNew);
                this.cardBusy = true
                this.ObjData = Object.assign({}, DataLeave)
                this.getDataLimitLeave()
                try {
                    const res = await this.$http.get(url)
                    if(res.status === 200){
                        this.ObjData.typeSum_1 = res.data.sick
                        this.ObjData.typeSum_2 = res.data.vacation
                        this.ObjData.typeSum_3 = res.data.monkhood
                        this.ObjData.typeSum_4 = res.data.extra
                        this.ObjData.typeSum_5 = res.data.medical
                        this.ObjData.typeSum_6 = res.data.casual
                        this.ObjData.typeSum_7 = res.data.maternity
                        this.ObjData.typeSum_8 = res.data.other
                        this.cardBusy = false
                    }else{
                        throw { res }
                    }
                } catch (error) {
                    this.cardBusy = false
                }
            },
            async getDataLimitLeave(){
                this.ObjDataLimit = Object.assign({}, DataLeaveLimit)
                try {
                    const res = await this.$http.get(`/hri/vacation_quota/?year=${this.YearDataNew}`)
                    if(res.status === 200){
                        this.ObjDataLimit.typeLimt = res.data[0].quota
                    }
                } catch (error) {}
            },
            openFormLeave(){
                this.$router.push({
                    path:"/writeformleave",
                }).catch(err => {})
            },
        }
    }
</script>

<style lang="scss" scoped>
    .jumbotron {
        padding: 1rem 1rem;
        background-color: #f3f1f1;
    }
    .jumbotron-custom {
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
        transition: 0.3s;
    }
    .popover-custom {
        border-radius: 10px;
        background-color:#def1ff;
        border: 1px solid #def1ff;
    }
    .L-smallIcon{ font-size: 0.95rem; color: #3e8bff; }
    .L-info{ font-family: 'Kanit', sans-serif; font-weight: 100; font-size: 0.95rem; }
    .L-head{ font-family: 'Baloo Tamma 2', cursive; }
    .L-Number{ font-family: 'Baloo Tamma 2', cursive; }
    .L-small{ font-family: 'Baloo Tamma 2', cursive; font-size: 0.75rem; }
    .custom-hr{ border-color: #dadada; }
    .f-2{ font-size: 1rem; }
    .fw-300{ font-weight: 300; }
</style>